const AT = {
  ibanLength: 20,
};
export { AT };
